import { NgModule } from '@angular/core';
import { NoSavedWritsComponent } from './no-saved-writs/no-saved-writs.component';
import { WritResultsComponent } from './results/results.component';
import { WritComponent } from './writ.component';
import { CommonModule } from '@angular/common';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchItemComponent } from './search/search-item/search-item.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CoreModule } from '@core/core.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExecutionDiffComponent } from './execution-diff/execution-diff.component';
import { UiModule } from 'src/app/ui/ui.module';
import { IconsModule } from 'src/app/ui/icons/icons.module';

@NgModule({
	declarations: [
		WritComponent,
		NoSavedWritsComponent,
		WritResultsComponent,
		SearchItemComponent,
		ExecutionDiffComponent,
	],
	imports: [
		CoreModule,
		AtomicModule,
		CommonModule,
		FormsModule,
		MatDialogModule,
		ReactiveFormsModule,
		MatTooltipModule,
		UiModule,
		IconsModule,
	],
	exports: [
		WritComponent,
		NoSavedWritsComponent,
		WritResultsComponent,
		SearchItemComponent,
	],
})
export class WritModule {}
